import type { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { CurrencySom } from 'shared/constants'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import type { MyObject, MyObjectStatus } from '../../model/types'

import s from './styles.module.scss'

interface Props {
  object: MyObject
  onClick?: () => void
}

const statusClassName: Record<MyObjectStatus, string> = {
  active: s.active,
  submitted: s.submitted,
  cancelled: s.cancelled,
}

export const MyObjectCard: FC<Props> = ({ object, onClick }) => {
  const { t } = useTranslation()
  const shouldShowAvailability = Boolean(object.startDate && object.endDate)

  const content = (
    <>
      <div className={s.statusRow}>
        <span
          className={clsx(
            'semi-bold-12',
            s.badge,
            statusClassName[object.status],
          )}
        >
          {object.statusLabel}
        </span>

        <span className={clsx('medium-12', s.price)}>
          {priceShow(String(object.price))}
          {` `}
          {CurrencySom}
        </span>
      </div>

      <div className={s.contentRow}>
        <div className={s.objectInfo}>
          <span className={clsx('semi-bold-14', s.title)}>{object.title}</span>
          <span className={clsx('regular-12', s.address)}>
            {object.address}
          </span>
        </div>

        {onClick ? (
          <AppIcon
            id={AllIcons.CHEVRON_CELL}
            width={24}
            height={24}
            className={s.icon}
          />
        ) : null}
      </div>

      {shouldShowAvailability ? (
        <>
          <div className={s.divider} />

          <span className={clsx('medium-12', s.dateBadge)}>
            {t('kyrgyzstan_block.my_objects.availability', {
              startDate: object.startDate,
              endDate: object.endDate,
            })}
          </span>
        </>
      ) : null}
    </>
  )

  return (
    <Paper
      padding={[12]}
      radius="16px"
      className={s.card}
    >
      {onClick ? (
        <button
          type="button"
          className={s.button}
          onClick={onClick}
        >
          {content}
        </button>
      ) : (
        <div className={s.button}>{content}</div>
      )}
    </Paper>
  )
}
